import Pusher from 'pusher-js'

const pusherAuthURL = `https://omlaexndk9.execute-api.eu-west-1.amazonaws.com/default/ctv-launcher` // AWS API Gateway URL

const generatePusher = function () {
    const pusher = new Pusher('79380df9bfa381637978', {
        authEndpoint: pusherAuthURL,
        cluster: 'eu'
    });
    return pusher
}

export default generatePusher



// WEBPACK FOOTER //
// ./src/modules/Pusher.js